<template>
  <div class="dynamic-dialog">
    <!-- eslint-disable-next-line vue/valid-v-for -->
    <!-- eslint-disable-next-line vue/no-v-model-argument -->
    <DDialog
      v-for="(instance) in instances"
      :key="instance.key"
      v-bind="instance.options"
      v-model="instance.visible"
      @close="closeListener({instance})"
    >
      <component v-bind="instance.data" :is="instance.content"></component>
    </DDialog>
  </div>
</template>

<script>
import { dynamicDialogEventBus } from './dynamicDialogService';
import DDialog from './index.vue';
export default {
  components: {
    DDialog,
  },
  data() {
    return {
      instances: [],
      currentInstance: null,
    };
  },
  methods: {
    openListener({ instance }) {
      instance.visible = true;
      this.instances = [...this.instances, instance];
    },
    closeListener({ instance, params, closeprev }) {
      const key = instance.key;
      let current = this.instances.find((i) => i.key === key);

      if (!current && closeprev && this.instances.length) {
        current = this.instances[this.instances.length - 1]
      }
      
      if (current) {
        current.visible = false;
        this.instances = this.instances.filter((i) => i.key !== key);
        if (current.options.onClose) {
          current.close({ data: params, type: 'close' });
        }
      }
      this.currentInstance = null;
    },
  },

  created() {
    dynamicDialogEventBus.$on('open', this.openListener);
    dynamicDialogEventBus.$on('close', this.closeListener);
  },

  beforeUnmount() {
    dynamicDialogEventBus.$off('open', this.openListener);
    dynamicDialogEventBus.$off('close', this.closeListener);
  },

}
</script>./dynamicDialogService